import { render, staticRenderFns } from "./EditLeadEvent.vue?vue&type=template&id=765b0c52&"
import script from "./EditLeadEvent.vue?vue&type=script&lang=js&"
export * from "./EditLeadEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports